import { Component, ViewChild } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { LeadsSingleComponent } from 'components/sale/leads/single/leads-single.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { CompanyContactModel } from 'models/generated/Entities.GormCrm.CompanyContact';
import { ContactModel } from 'models/generated/Entities.GormCrm.Contact';
import { ContactPhoneModel } from 'models/generated/Entities.GormCrm.ContactPhone';
import { BusinessDtoModel } from 'models/generated/Models.LeadsApi.BusinessDto';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyService } from 'services/company.service';
import { CredentialRequired } from 'services/credential.service';
import { LeadsService } from 'services/leads.service';
import { ComponentUrl } from 'services/navigation.service';

@Component({
	selector: 'leads-list',
	templateUrl: './leads-list.component.html',
	imports: [Layout, DataTableComponent, DataRowComponent, CustomInputComponent, SubmitButtonComponent, ListView, LeadsSingleComponent, TranslatePipe]
})
@ComponentUrl('leads-list')
@CredentialRequired(CredentialType.ProductAccessLevelSales, CredentialType.BetaUserAccess)
export class LeadsListComponent {
	@ViewChild('leadsSearchButton') leadsSearchButton?: SubmitButtonComponent;
	zip: string | undefined;
	leadCompanys: BusinessDtoModel[] = [];
	inputTypeEnum = InputType;
	selectedCompany?: CompanyModel;
	selectedLeadCompany?: BusinessDtoModel;

	constructor(private readonly leadsService: LeadsService,
		private readonly companyService: CompanyService) {
	}

	onSearch() {
		this.selectedCompany = undefined;
		this.leadCompanys = [];
		if (this.zip !== undefined && this.zip.length > 0) {
			this.leadsService.getLeads(this.zip, 100).then((result: BusinessDtoModel[]) => {
				this.leadCompanys = result;
				this.leadsSearchButton!.reset();
			});
		}
	}

	selectLeadCompany(company: BusinessDtoModel) {
		this.selectedCompany = undefined;
		var newCompany = new CompanyModel();
		newCompany.name = company.name;
		newCompany.address = company.address;
		newCompany.zipcode = company.zip;
		newCompany.city = company.city;
		newCompany.vatNumber = this.leadsService.getVatNumber(company);
		newCompany.country = this.leadsService.getCountryCode(company);

		var contact = new ContactModel();
		contact.emailAddress = company.email;
		var contactPhoneModel = new ContactPhoneModel();
		contactPhoneModel.number = company.phone;
		contact.contactPhones.push(contactPhoneModel);

		newCompany.primaryContact = contact;

		var companyContact = new CompanyContactModel();
		companyContact.company = newCompany;
		companyContact.contact = contact;
		newCompany.companyContacts.push(companyContact);

		newCompany.include(c => c.primaryContact);
		newCompany.include(c => c.companyContacts);
		newCompany.companyContacts.forEach(cc => {
			cc.include(c => c.contact);
			cc.contact!.include(c => c.contactPhones);
		});

		this.companyService.getOrCreateCompany(newCompany).then(newCompany => {
			this.selectedCompany = newCompany;
			this.selectedLeadCompany = company;
		});
	}
}
